import {
  Box,
  FormControl,
  FormErrorMessage,
  Heading,
  Input,
  SimpleGrid,
  Stack,
  Text,
  Textarea,
  VStack,
} from '@chakra-ui/react';
import {useTranslation} from 'hooks';
import {FC} from 'react';

interface Props {
  onChange: (key: string, value: any) => void;
  values: {
    apartment: string;
    entrance?: number;
    floor?: number;
    entrance_code?: string;
    comment?: string;
  };
  errors: any;
}

export const Form: FC<Props> = ({onChange, values, errors}) => {
  const {t} = useTranslation();
  const showAddressInputs = true;

  const handleInputChange = (e: React.ChangeEvent<any>) => {
    const {id, value} = e.target;
    onChange(id, value);
  };

  return (
    <VStack alignItems="flex-start" w="full" spacing="0">
      <Stack w="full">
        {showAddressInputs && (
          <SimpleGrid
            spacing={['8px', '15px']}
            mt="0"
            columns={[2, 4]}
            pb={['15px', '30px']}
            sx={{
              input: {
                marginTop: '6px',
              },
              label: {
                maxW: '150px',
              },
            }}
          >
            <Text as="label" fontWeight={600}>
              {t('ADDRESS_APT_OFFICE')}
              <FormControl isInvalid={!!errors['apartment']}>
                <Input
                  placeholder="0"
                  id="apartment"
                  name="apartment"
                  type="text"
                  onChange={handleInputChange}
                  value={values.apartment}
                />
                <FormErrorMessage>{errors['apartment']}</FormErrorMessage>
              </FormControl>
            </Text>
            <Text as="label" fontWeight={600}>
              {t('STAIRS')}
              <FormControl isInvalid={!!errors['entrance']}>
                <Input
                  placeholder="0"
                  id="entrance"
                  name="entrance"
                  type="number"
                  onChange={handleInputChange}
                  value={values.entrance}
                />
                <FormErrorMessage>{errors['entrance']}</FormErrorMessage>
              </FormControl>
            </Text>
            <Text as="label" fontWeight={600}>
              {t('FLOOR')}
              <FormControl isInvalid={!!errors['floor']}>
                <Input
                  placeholder="0"
                  id="floor"
                  name="floor"
                  type="number"
                  onChange={handleInputChange}
                  value={values.floor}
                />
                <FormErrorMessage>{errors['floor']}</FormErrorMessage>
              </FormControl>
            </Text>
            <Text as="label" fontWeight={600}>
              {t('INTER_PHONE')}
              <Input
                placeholder="0"
                id="entrance_code"
                name="entrance_code"
                type="text"
                onChange={handleInputChange}
                value={values.entrance_code}
                maxLength={20}
              />
            </Text>
          </SimpleGrid>
        )}
        <Box pb="30px" w="full">
          <Heading as="h3" mb="15px" fontWeight={600} fontSize="1rem">
            {t('SPECIAL_MENTIONS')}
          </Heading>
          <Textarea
            id="comment"
            name="comment"
            placeholder={t('ADD_SPECIAL_MENTIONS')}
            value={values.comment}
            onChange={handleInputChange}
            maxLength={200}
          />
        </Box>
      </Stack>
    </VStack>
  );
};
